export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11876.16b089d6.jpg";